export const JACKET_SIDES = {
  FRONT: 'front',
  BACK: 'back',
  LEFT: 'left',
  RIGHT: 'right',
};

export const JACKET_TYPE = {
  SET_IN: 'Set-In',
  RAGLAN: 'Raglan',
};

export const JACKET_MENU = {
  JACKET: 'jacket',
  COLLAR: 'collar',
  BODY: 'body',
  SLEEVES: 'sleeves',
  TRIM: 'trim',
  SNAPS: 'snaps',
  POCKETS: 'pockets',
  LINING: 'lining',
};

export const COLLARS = {
  CLASSIC: 'classic',
  HOODIE: 'hoodie',
  ZIPPER_HOOD: 'zipper-hood',
};

export const TRIM_PATTERNS = {
  PATTERN_A: 'PatternA',
  PATTERN_B: 'PatternB',
  PATTERN_C: 'PatternC',
  PATTERN_D: 'PatternD',
  PATTERN_E: 'PatternE',
  PATTERN_F: 'PatternF'
};

export const SIZES_NUMBERS = {
  XS: 1,
  S: 2,
  M: 3,
  L: 4,
  XL: 5,
  XXL: 6,
  XXXL: 7,
  XXXXL: 8
};

export const SIZES_VALUES = {
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  XXL: '2XL',
  XXXL: '3XL',
  XXXXL: '4XL'
};

export const SIZES = [
  { value: null, text: '--Select--' },
  { value: SIZES_NUMBERS.XS, text: SIZES_VALUES.XS },
  { value: SIZES_NUMBERS.S, text: SIZES_VALUES.S },
  { value: SIZES_NUMBERS.M, text: SIZES_VALUES.M },
  { value: SIZES_NUMBERS.L, text: SIZES_VALUES.L },
  { value: SIZES_NUMBERS.XL, text: SIZES_VALUES.XL },
  { value: SIZES_NUMBERS.XXL, text: SIZES_VALUES.XXL },
  { value: SIZES_NUMBERS.XXXL, text: SIZES_VALUES.XXXL },
  { value: SIZES_NUMBERS.XXXXL, text: SIZES_VALUES.XXXXL },
];

export const BODY_SLEEVE_LENGTH_VALUES = {
  NO_CHANGE: 'No Changes',
  SHORTEN_1: 'Shorten 1"',
  SHORTEN_2: 'Shorten 2"',
  SHORTEN_3: 'Shorten 3"',
  LENGTHEN_1: 'Lengthen 1"',
  LENGTHEN_2: 'Lengthen 2"',
  LENGTHEN_3: 'Lengthen 3"',
};

export const BODY_SLEEVE_LENGTH_NUMBERS = {
  NO_CHANGE: null,
  SHORTEN_1: 1,
  SHORTEN_2: 2,
  SHORTEN_3: 3,
  LENGTHEN_1: 4,
  LENGTHEN_2: 5,
  LENGTHEN_3: 6,
};

export const BODY_SLEEVE_LENGTH = [
  { value: null, text: BODY_SLEEVE_LENGTH_VALUES.NO_CHANGE },
  { value: BODY_SLEEVE_LENGTH_NUMBERS.SHORTEN_1, text: BODY_SLEEVE_LENGTH_VALUES.SHORTEN_1 },
  { value: BODY_SLEEVE_LENGTH_NUMBERS.SHORTEN_2, text: BODY_SLEEVE_LENGTH_VALUES.SHORTEN_2 },
  { value: BODY_SLEEVE_LENGTH_NUMBERS.SHORTEN_3, text: BODY_SLEEVE_LENGTH_VALUES.SHORTEN_3 },
  { value: BODY_SLEEVE_LENGTH_NUMBERS.LENGTHEN_1, text: BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_1 },
  { value: BODY_SLEEVE_LENGTH_NUMBERS.LENGTHEN_2, text: BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_2 },
  { value: BODY_SLEEVE_LENGTH_NUMBERS.LENGTHEN_3, text: BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_3 },
];

export const SNAPSTYLE = [
  { value: 'Male', text: 'Male (left over right)' },
  { value: 'Female', text: 'Female (right over left)' },
];

export const LINING_VALUES = {
  QUILT_LINING: 'Quilt Lining',
  NYLON_LINING: 'Nylon Lining',
};

export const LINING = [
  { value: LINING_VALUES.QUILT_LINING, text: LINING_VALUES.QUILT_LINING },
  { value: LINING_VALUES.NYLON_LINING, text: LINING_VALUES.NYLON_LINING },
];

export const TAG_LIST = [
  { value: 'aHex', text: 'Primary Color' },
  { value: 'bHex', text: '2nd Color' },
  { value: 'static', text: 'Static Color' }
];

export const ONE_INCH_IN_PX = 96;

export const PATCH_INCH_IN_PX = 12;
export const FRESHMAN_FONT_INCH_IN_PX = 10;
export const CLOISTRK_FONT_INCH_IN_PX = 13;

export const TEXT_EMBROIDERY_PATCH_INCH_IN_PX = 16;
export const TEXT_EMBROIDERY_FRESHMAN_FONT_INCH_IN_PX = 13;
export const TEXT_EMBROIDERY_CLOISTRK_FONT_INCH_IN_PX = 17;

export const getInchInPx = (patch) => {
  if (patch.isTextPatch) {
    if (patch.isTextEmbroidery) {
      if (patch.font === 'Freshman') {
        return TEXT_EMBROIDERY_FRESHMAN_FONT_INCH_IN_PX;
      }

      if (patch.font === 'cloistrk') {
        return TEXT_EMBROIDERY_CLOISTRK_FONT_INCH_IN_PX;
      }

      return TEXT_EMBROIDERY_PATCH_INCH_IN_PX;
    }

    if (patch.font === 'Freshman') {
      return FRESHMAN_FONT_INCH_IN_PX;
    }

    if (patch.font === 'cloistrk') {
      return CLOISTRK_FONT_INCH_IN_PX;
    }
  }

  return PATCH_INCH_IN_PX;
};
